import SettlementIcon from "@mui/icons-material/Handshake";
import { ButtonBase } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useTheme } from "../../context/ThemeContext";
import { TonalBadge } from "../general/TonalBadge";
import { Defendant } from "./IssueModel.ts";

/**
 * With whom a claim has been settled, as a way into the settlements: neutral
 * while nobody has settled, a warning tone while only some have, and the tone
 * of a good outcome once all have.
 */
const SettledDefendants = ({ defendants }: { defendants: Defendant[] }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { t } = useTranslation(undefined, {
    keyPrefix: "case.claims",
  });

  const settledDefendants = defendants
    .filter(({ settled }) => settled)
    .map(({ name }) => name);
  const none = settledDefendants.length === 0;
  const all = settledDefendants.length === defendants.length;

  return (
    <ButtonBase
      onClick={() => navigate("../settlement")}
      sx={{ borderRadius: 1.25 }}
    >
      <TonalBadge
        tone={
          none
            ? undefined
            : all
              ? theme.palette.data.positive
              : theme.palette.warning
        }
        sx={{ py: 0.5, fontWeight: 600 }}
      >
        <SettlementIcon fontSize="inherit" />
        {none
          ? t("settledDefendants.none")
          : all
            ? t("settledDefendants.all")
            : t("settledDefendants.some", { names: settledDefendants })}
      </TonalBadge>
    </ButtonBase>
  );
};

export default SettledDefendants;
